var OrderOptionsModelV2 = function (pageModelHndl) {
    var that = this;

    that.IsLoading = ko.observable(false);
    that.IsDependencyLoading = ko.computed(function() {
        return pageModelHndl.pPriceTableModelV2.IsLoading()
            || pageModelHndl.pPriceTableModelV2.IsDependencyLoading();
    }, this, { pure: true });

    that.SelectedDeliveryCountryId = ko.observable(pageModelHndl.DefaultDeliveryCountryId());
    that.SelectedOrderOptions = ko.observableArray([]);

    that.WriteSelectedOption = function(data, event) {
        console.log("You clicked " + event.target.id);
    };

    that.WriteSelectedDeliveryCountry = function(data, event) {
        console.log("You clicked " + event.target.id);
    };

    var getOrderOption = function (array, optionType) {
        for (var i = 0, length = array.length; i < length; i++) {
            if (array[i].optionType === optionType) {
                return array[i];
            }
        }
    };

    that.addSelectedOrderOption = function(optionType, optionId, isInitial) {
        if (that.SelectedOrderOptions().length > 0) {
            var result = getOrderOption(that.SelectedOrderOptions(), optionType);
            result && that.SelectedOrderOptions.remove(result);
        }
        if (optionType === "ProductionType") {
            pageModelHndl.pPriceTableModelV2.ProductionTimeTypeId(optionId);
            pageModelHndl.pPriceTableModelV2.SetSelectedClass();
        }        
        that.SelectedOrderOptions.push({
             'optionType': optionType, 
             'optionId': optionId
        });
        if (!isInitial && optionType === "PrintType") {
            that.LoadOrderOptionsData();
        }
    };  

    var updateOrderOptionsBeginner = function(input) {
        var url = $("#productConfigurationBeginnerOrderOptionsV2").data("url");

        that.IsLoading(true);
        return $.ajax({
            type: "POST",
            contentType: "application/json",
            url: url,
            data: input,
            datatype: "html"
        }).done(function(result) {
            $("#beginnerOrderOptionsContainer").html(result);
        }).fail(function() {
            alerts.error();
        }).always(function() {
            that.IsLoading(false);
        });
    };

    var updateOrderOptions = function(input) {
        var url = $("#productConfigurationOrderOptionsV2").data("url");

        that.IsLoading(true);
        return $.ajax({
            type: "POST",
            contentType: "application/json",
            url: url,
            data: input,
            datatype: "html"
        }).done(function(result) {
            $("#orderOptionsContainer").html(result);
        }).fail(function() {
            alerts.error();
        }).always(function() {
            that.IsLoading(false);
        });
    };

    var updateConfigurationSummary = function () {
        return pageModelHndl.pSummaryModel.load(
            pageModelHndl.pPriceTableModelV2.ArticleReference(),
            pageModelHndl.pPriceTableModelV2.Amount(),
            that.SelectedOrderOptions(),
            that.SelectedDeliveryCountryId(),
            pageModelHndl.pAdditionalWorkModelV2.SelectedAdditionalWork());
    };

    that.LoadOrderOptionsData = function() {
        if (pageModelHndl.pPriceTableModelV2.ProductionTimeTypeId()) {
            that.addSelectedOrderOption("ProductionType", pageModelHndl.pPriceTableModelV2.ProductionTimeTypeId());
        }
        
        var input = JSON.stringify({
            selectedOrderOptions: that.SelectedOrderOptions(),
            selectedDeliveryCountry: that.SelectedDeliveryCountryId(),
            articlereference: pageModelHndl.pPriceTableModelV2.ArticleReference(),
            amount: pageModelHndl.pPriceTableModelV2.Amount(),
            isCatalogueProduct: pageModelHndl.IsCatalogueProduct(),
            selectedAdditionalWorkIds: pageModelHndl.pAdditionalWorkModelV2.SelectedAdditionalWork()
        });

        $(document).trigger('gridLayoutIeApply');

        return updateOrderOptions(input)
            .then(updateOrderOptionsBeginner(input))
            .then(function (result) {
            
            if (pageModelHndl.IsScrollingRequired()) {
                pageModelHndl.IsScrollingRequired(false);
                try {
                    scrollTo("#configStart", function () { });
                } catch (err) {
                    console.log("#productContentModeDiv not found");
                }
            }

            updateConfigurationSummary();
        });
    };

    that.UpdateProductionType = function(productionTypeId) {
        var productionType = "ProductionType";
        that.addSelectedOrderOption(productionType, productionTypeId);
        that.SyncBeginnerView(productionType, productionTypeId);
        that.SyncDefaultView(productionType, productionTypeId);
        updateConfigurationSummary();
    };

    that.SyncBeginnerView = function(optionType, optionId) {
        var el = $("#OrderOptionBeginner[data-optiontype='" + optionType + "']");
        el.val(optionId);
    };

    that.SyncDefaultView = function(optionType, optionId) {
        var el = $(".OrderOptionList .option-click[data-optiontype='" + optionType + "'][data-optionid='"+ optionId + "'] :input");
        el.prop("checked", true);

        // update selected option label
        var clickedOptionLabel = $("span[name='"+optionType+"-"+optionId+"-label']");
        var clickedOptionPrice = $("span[name='"+optionType+"-"+optionId+"-price']");
        
        var selectedOptionLabel = $("#"+optionType+"-selected-value");
        var selectedOptionPrice = $("#"+optionType+"-selected-price");
        selectedOptionLabel.text(clickedOptionLabel.text());
        selectedOptionPrice.text(clickedOptionPrice.text());
    };
    
    $(function() {
        var contextElement = $("#productConfigurationMainDiv");
        
        contextElement.on("change", "#SelectedCountryId",
            function() {
                if (this.value === undefined) return
                that.SelectedDeliveryCountryId(this.value);
                that.LoadOrderOptionsData();
            });
        
        contextElement.on("click", ".OrderOptionList .option-click input",
            function() {
                var optionType = $(this).parent().parent().data("optiontype");
                var optionId = $(this).parent().parent().data("optionid");
                that.addSelectedOrderOption(optionType, optionId);
                that.SyncBeginnerView(optionType, optionId);
                updateConfigurationSummary();
            });

        contextElement.on("click", ".OrderOptionList .option-click",
            function() {
                var optionType = $(this).data("optiontype");
                var optionId = $(this).data("optionid");
                that.addSelectedOrderOption(optionType, optionId);
                that.SyncDefaultView(optionType, optionId);
                updateConfigurationSummary();
            });

        contextElement.on("change", "#OrderOptionBeginner",
            function() {
                var optionType = $(this).data("optiontype");
                var optionId = this.value;
                that.addSelectedOrderOption(optionType, optionId);
                that.SyncDefaultView(optionType, optionId);
                updateConfigurationSummary();
            });

        contextElement.on("click", '[data-clickable="true"]',
            function() {                
                var optionType = $(this).data("optiontype");
                var orderOptionList = $("#"+optionType+"-OrderOptionList");
                var collapsibleIcon = $("#"+optionType+"-collapsible-icon");

                var isCollapsed = orderOptionList.hasClass("h-0");
                if (isCollapsed) {
                    orderOptionList.css("opacity", "1");
                    orderOptionList.css("transition", "all .2s ease-in-out")
                    collapsibleIcon.css("rotate", "180deg");
                } else {
                    orderOptionList.css("opacity", "0");
                    orderOptionList.css("transition", "unset") // Avoid transition when collapsing
                    collapsibleIcon.css("rotate", "0deg");
                }
                orderOptionList.toggleClass("h-0");
            });
    });
};